// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lineP > p[data-v-2bbddf4d] {\n  margin-top: 0.1rem;\n  display: flex;\n  align-items: center;\n}\n.lineP > p > div[data-v-2bbddf4d] {\n    width: 2rem;\n}\n.lineP > p > span[data-v-2bbddf4d] {\n    width: 1rem;\n    display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
